<div class="quantity-selector">
    <button (click)="decrement()">-</button>
    <input type="text" [value]="quantity" readonly>
    <button (click)="increment()">+</button>
  </div>